//TODO: define hierarchy
export enum FilterType {
  SEARCH = "search",
  PAGINATOR = "paginator",
  SORT = "sort",
}
